<template>
	<div>
		<div class="s-img">
			<img src="../assets/images/contact/17-1.jpg" />
		</div>
		<div class="s-img">
			<img src="../assets/images/contact/17-1_01.jpg" />
		</div>
		<div class="s-img">
			<img src="../assets/images/contact/17-1_02.jpg" />
		</div>
		<div class="s-img">
			<img src="../assets/images/contact/17-1_03.jpg" />
		</div>
		<div id="myDiv"></div>
		<contactModule :titleName="titleName" :typeInt="2" />
		<div class="c-bg">
			<div class="c-img">
				<img src="../assets/images/contact/17-1_05.jpg" />
			</div>
			<div class="c-Module">
				<div class="c-l">
					<img src="../assets/images/contact/l1.png" @click="tabMapj" />
					<img src="../assets/images/contact/l2.png" @click="tabMapH" />
				</div>
				<div class="c-r">
					<div class="mapClass" ref="mapContainer"></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import contactModule from '@/components/contactModule.vue'
	export default {
		components: {
			contactModule
		},
		data() {
			return {
				titleName:'期待与您的合作',
				lat:30.728005,
				lng:120.716607,
				toPosition:0
			}
		},
		mounted() {
			var self = this
			// 获取路由参数
			let cInfo = this.$route.query;
			if(cInfo.toPosition){
				setTimeout(function(){
					document.getElementById('myDiv').scrollIntoView({ behavior: 'smooth' })
				},500)
			}
			
			this.initMap(this.lat,this.lng)
		},
		methods:{
			// 初始化地图
			initMap(lat,lng) {
				let self = this;
				 const mapContainer = this.$refs.mapContainer; // 获取地图容器元素
				const map = new qq.maps.Map(mapContainer, { // 初始化地图实例
					center: new qq.maps.LatLng(lat, lng), // 设置地图中心点坐标
					zoom: 15 // 设置地图缩放级别
				});
				
				// 添加标记点
				const marker = new qq.maps.Marker({ // 创建标记点对象
					position: new qq.maps.LatLng(lat, lng), // 设置标记点位置为指定坐标点
					map: map // 将标记点添加到地图上
				});
				
			},
			tabMapj(){
				var self = this
				const lat = 30.728005
				const lng = 120.716607
				self.initMap(lat, lng)
			},
			tabMapH(){
				var self = this
				const lat = 30.683492
				const lng = 114.136551
				self.initMap(lat, lng)
			},
		}
	}
</script>

<style>
	.c-bg{
		width: 100%;
		padding-bottom: 1rem;
		/* background: url('../assets/images/contact/mBg.jpg') no-repeat; */
		/* background-size: 100% 100%; */
	}
	.c-img{
		width: 71%;
		margin: 1.5vw auto;
	}
	.c-Module{
		width: 70%;
		margin: 0 auto;
		padding-bottom: 1rem;
		overflow: hidden;
	}
	.c-title{
		padding-top: 2rem;
		font-size: 1.7vw;
		font-weight: 900;
	}
	.c-spec{
		font-size: 1.4vw;
	}
	@media screen and (max-width:750px) {
		.c-title{
			font-size: 1rem;
		}
		.c-spec{
			font-size: .8rem;
		}
		.c-l{
			width: 100%;
		}
		.c-r{
			width: 100%;
			overflow: hidden;
		}
	}
	/* ==========PC样式====== */
	@media screen and (min-width:755px) {
		.c-Module{
			display: flex;
			justify-content: space-between;
		}
		.c-l{
			width: 35%;
		}
		.c-r{
			width: 54.5%;
			height: 15vw;
			border-radius: 1rem;
			overflow: hidden;
		}
	}
	.c-l img{
		cursor: pointer;
	}
	/* ======================== */
	.mapClass{
		width: 100%;
		height: 100%;
	}
</style>